<!-- Wrapper -->
<div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper">
    <!-- Sidebar -->
    <div app-home-sidebar></div>

    <!-- Content -->
    <div class="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
        <router-outlet></router-outlet>
    </div>
</div>